import React from 'react';
import { motion } from 'framer-motion';
import { InfoIcon, ActivityIcon, ClockIcon, RotateCwIcon, CalendarIcon } from 'lucide-react';
export function VideoSection() {
  const bullets = [{
    icon: InfoIcon,
    text: 'What Class IV laser therapy is and how it works'
  }, {
    icon: ActivityIcon,
    text: 'How the treatment is performed by our providers'
  }, {
    icon: ClockIcon,
    text: 'What patients typically experience during a session'
  }, {
    icon: RotateCwIcon,
    text: 'Why multiple visits may be recommended for optimal results'
  }];
  return <section id="video-section" className="py-20 md:py-28 bg-white" data-id="element-273">
      <div className="container mx-auto px-4 max-w-6xl" data-id="element-274">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-275">
          <h2 className="text-3xl md:text-5xl font-bold text-brand-navy mb-6" data-id="element-276">
            Watch the Aspen Laser Patient Education Video
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center" data-id="element-277">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="lg:col-span-7" data-id="element-278">
            <div className="relative w-full aspect-video rounded-2xl overflow-hidden shadow-2xl ring-1 ring-gray-900/5" data-id="element-279">
              <iframe className="absolute top-0 left-0 w-full h-full" src="https://www.youtube.com/embed/fJ5evRvEv0s" title="Aspen Laser Patient Education" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen data-id="element-280"></iframe>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.4
        }} className="lg:col-span-5 flex flex-col justify-center" data-id="element-281">
            <p className="text-lg text-gray-600 mb-8 leading-relaxed" data-id="element-282">
              This brief educational video helps patients understand the science
              behind laser therapy, what it feels like, what conditions it may
              help with, and what to expect from your personalized treatment
              plan.
            </p>

            <ul className="space-y-4 mb-10" data-id="element-283">
              {bullets.map((bullet, index) => <li key={index} className="flex items-start gap-3" data-id="element-284">
                  <div className="mt-1 bg-brand-teal/10 p-1.5 rounded-full text-brand-teal" data-id="element-285">
                    <bullet.icon className="w-5 h-5" data-id="element-286" />
                  </div>
                  <span className="text-gray-700 font-medium leading-relaxed" data-id="element-287">
                    {bullet.text}
                  </span>
                </li>)}
            </ul>

            <button className="w-full sm:w-auto px-8 py-4 bg-brand-teal hover:bg-brand-teal-dark text-white rounded-lg font-semibold text-lg transition-all duration-300 flex items-center justify-center gap-2 shadow-lg shadow-brand-teal/25 self-start" data-id="element-288">
              <CalendarIcon className="w-5 h-5" data-id="element-289" />
              Schedule a Consultation
            </button>
          </motion.div>
        </div>
      </div>
    </section>;
}